import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import Card from "../card"

export const SeeMoreLink = styled.button`
  color: ${(props) => props.theme.colors.brand};
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 400;
  padding: 0;
  font-size: 16px;
  margin-top: 0.8rem;
  width: 100%;

  display: flex;
  align-items: center;
  gap: 4px;

  > svg {
    font-size: 0.875rem;
  }
`

export const Container = styled.div`
  display: grid;
  gap: 1rem;

  ${breakpoint("desktop")`
    display: flex;
    align-items: flex-start;
    gap: 2rem;
  `}

  &:empty {
    display: none;
  }

  ${({ gridArea }) =>
    gridArea !== undefined &&
    css`
      ${breakpoint("tablet")`
      grid-area: ${gridArea};
    `}
    `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      ${breakpoint("desktop")`
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
      `}
    `}

  ${({ fullWidthVideo }) =>
    !!fullWidthVideo &&
    css`
      ${breakpoint("desktop")`
        flex-direction: column;
        align-items: stretch;
        gap: 0;
      `}
    `}
`

export const ContentContainer = styled(Card)`
  user-select: text;

  &:empty {
    display: none;
  }

  ${({ inlineOnMobile }) =>
    !!inlineOnMobile &&
    breakpoint("mobile", "tablet")`
    display: none;
  `}
`

export const SimpleFormContentContainer = styled(Card).attrs({
  variant: "white",
  simpleFormContent: true
})`
  user-select: text;
  width: unset;
  margin-bottom: 16px;
  border: 1px solid #e6e6e6;
  overflow: auto;

  ${breakpoint("tablet")`
    width: auto;
  `}

  ${(props) =>
    !!props.marginless &&
    css`
      margin-bottom: 0;
    `}

  ${(props) =>
    !!props.fullWidthVideo &&
    !!props.simpleForm &&
    css`
      display: flex;
      flex-direction: column;

      ${breakpoint("tablet")`
        padding: 24px;
        align-items: flex-start;
        gap: 24px;
        align-self: stretch;
        flex-direction: row;
        flex-wrap: wrap;

        ${
          !!props.splitContainer &&
          css`
            > div {
              flex: 1;
            }
          `
        }
      `}
    `}
  &:empty {
    display: none;
  }
`
export const ProfileContentContainer = styled.div`
  user-select: text;
  width: unset;
  margin-bottom: 16px;

  ${breakpoint("tablet")`
    width: auto;
  `}

  &:empty {
    display: none;
  }
`

export const MobileContentContainer = styled(Card).attrs({
  paddingless: true,
  variant: "transparent"
})`
  user-select: text;

  &:empty {
    display: none;
  }

  ${breakpoint("tablet")`
    display: none;
  `}
`

export const VideoContainer = styled(Card).attrs({
  paddingless: true
})`
  ${({ simpleForm }) =>
    !simpleForm &&
    css`
      ${breakpoint("desktop")`
        flex: 0 0 45%;
      `}
    `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      max-width: 672px;
      margin-top: 0.5rem;
      background: transparent;
    `}

  ${({ fullWidthVideo, simpleForm }) =>
    !!fullWidthVideo &&
    css`
      width: 100%;

      ${breakpoint("tablet")`
        ${!!simpleForm && "width: 66%;"}
      `}
    `}
`

export const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0%;
  border-radius: inherit;
`

export const Video = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
`
